module.exports = require("victory");